import type { ApiUserAccount } from 'src/types/userAuth';
import type { ApiVerifySignedChallengePayload } from 'src/types/wallet';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios from 'src/utils/axios';

import { QueryKeys } from './QueryKeys';

/**
 * POST /user/wallet/link — links the connected wallet to the signed-in account. The body is a
 * challenge signed by that wallet (`useWalletSecondFactor`, purpose `auth`). The wallet
 * belonging to another account returns 409. Since the e-mail-only sign-in (api#402) this is how
 * a wallet enters the storefront at all: the first one linked becomes the account's primary.
 */
export const useLinkWallet = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: ApiVerifySignedChallengePayload): Promise<ApiUserAccount> => {
      const response = await axios.post<ApiUserAccount>(`/user/wallet/link`, payload);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QueryKeys.userMe() });
    },
  });
};
